exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-active[data-v-b5074a16]{text-decoration:underline}#food-diary-buttons[data-v-b5074a16]{height:10vh;padding:2vh 0;background:transparent}.button[data-v-b5074a16]{padding:1vh;display:flex;flex-direction:row;align-items:center;cursor:pointer;color:#fff;transition:.2s ease-in-out}.button[data-v-b5074a16]:hover{transform:scale(.9)}.button i[data-v-b5074a16]{margin-right:2vh}.button p[data-v-b5074a16]{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5074a16","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Functions.vue
// module id = 40
// module chunks = 0